import { render, staticRenderFns } from "./InsuranceToDisease.vue?vue&type=template&id=44f94efa&scoped=true&"
import script from "./InsuranceToDisease.vue?vue&type=script&lang=js&"
export * from "./InsuranceToDisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f94efa",
  null
  
)

export default component.exports